import styled from 'styled-components';

export const DialogContent = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  
  .form-fields {
    display: flex;
    flex-direction: row;
    gap: 8px;
    padding: 12px 20px 20px 20px;
    border-bottom: 2px solid #d6d6d6;
    height: 118px;
    box-sizing: content-box;

    .form-fields-left {
      display: flex;
      flex-direction: column;
    }

    .form-fields-right {
      display: flex;
      flex-direction: column;
    }
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 12px;
  flex-direction: column;

  button {
    margin-bottom: 12px;

    &:last-child {
      margin-left: 0px;
    }
  }
`;

export const StyledTitle = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  button {
    padding: 0px !important;
  }
`;

export const CustomButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px 20px;

  column-gap: 8px;
`